import Lenis from 'lenis'

export default defineNuxtPlugin((nuxtApp) => {
    if (import.meta.server) return

    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Expo Out
        smoothWheel: true,
        // mouseMultiplier: 1,
        // smoothTouch: false,
        touchMultiplier: 2,
    })

    // Hook into requestAnimationFrame
    function raf(time: number) {
        lenis.raf(time)
        requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)

    // OPTIONAL: Inject for usage in components
    // nuxtApp.provide('lenis', lenis)
})
